import { supertypeClass, property, Remoteable, Supertype } from '@haventech/amorphic';

@supertypeClass({ toClient: true, toServer: true })
export class PaymentInformation extends Remoteable(Supertype) {
  @property({ rule: ['required', 'text'], logChanges: true, comment: "Payer's bank name for ach" })
  paymentBankName: string;

  @property({
    rule: ['required', 'numericstring'],
    length: 9,
    validate: 'isMinLength(9);isMaxLength(9)',
    logChanges: true,
    comment: "Payer's ABA.",
  })
  paymentABA: string;

  @property({
    rule: ['required', 'numericstring'],
    validate: 'isMaxLength(17)',
    logChanges: true,
    sensitiveData: true,
    comment: "Payer's account number",
  })
  paymentAccount: string;

  @property({
    rule: ['required'],
    values: function () {
      return ['2', '1'];
    },
    descriptions: {
      '1': 'Savings',
      '2': 'Checking',
      '3': 'Personal Checking',
      '4': 'Personal Savings',
      '5': 'Business Checking',
      '6': 'Business Savings',
    },
    comment: "payment account type, values='1:Checking,2:Saving'",
  })
  paymentAccountType: string;

  @property({
    values: ['true', 'false'],
    comment: "Boolean, 'true' means that the applicant is opting for Autopay (Automatic payment of policy premium).",
  })
  isAutoPay: boolean;

  static new() {
    return new PaymentInformation();
  }

  constructor() {
    super();
  }
}
